import React from 'react';
import { Helmet } from 'react-helmet';


function Contact_Us_Seo() {
    return (
        <div>
            <Helmet>
                <title>Contact Us | Ifepay</title>
                <meta name="description" content="Call us on 02030061093 or email us at info@ifepay.co.uk We would like to answer any questions you got regarding sending money to Nigeria. Contact us today." />
                <meta property="og:title" content="Contact Us | Ifepay" />
                <meta property="og:description" content="Call us on 02030061093 or email us at info@ifepay.co.uk We would like to answer any questions you got regarding sending money to Nigeria. Contact us today." />
                <meta property="og:image" content="https://ifepay.co.uk/assets/images/logo.png" />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://ifepay.co.uk/contact-us" />
            </Helmet>
        </div>
    )
}

export default Contact_Us_Seo
